var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { createContext, useContext, useEffect, useRef, useState, } from 'react';
import { useDebounce } from 'use-debounce';
var GroupGeofencePageContext = createContext(null);
var useGroupGeofencePageContext = function () { return useContext(GroupGeofencePageContext); };
export var GroupGeofenceMode;
(function (GroupGeofenceMode) {
    GroupGeofenceMode["Geofence"] = "geofence";
    GroupGeofenceMode["AddLocation"] = "add-location";
})(GroupGeofenceMode || (GroupGeofenceMode = {}));
export var GroupGeofenceAction;
(function (GroupGeofenceAction) {
    GroupGeofenceAction["AddGeofence"] = "add-geofence";
    GroupGeofenceAction["UpdateGeofence"] = "update-geofence";
})(GroupGeofenceAction || (GroupGeofenceAction = {}));
var GroupGeofencePageContextProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useState(null), 2), selectedGeofence = _b[0], setSelectedGeofence = _b[1];
    var _c = __read(useState(false), 2), postGeofenceModal = _c[0], setPostGeofenceModal = _c[1];
    var _d = __read(useState({
        metaData: {
            currentPage: 1,
            totalPages: 1,
            totalItems: 0,
            itemsPerPage: 10,
        },
        data: [],
    }), 2), geofences = _d[0], setGeofences = _d[1];
    var _e = __read(useState(), 2), mode = _e[0], setMode = _e[1];
    var _f = __read(useState(''), 2), searchText = _f[0], setSearchGeofence = _f[1];
    var _g = __read(useDebounce(searchText, 500), 1), searchGeofence = _g[0];
    var _h = __read(useState(GroupGeofenceAction.AddGeofence), 2), geofenceAction = _h[0], setGeofenceAction = _h[1];
    var contextModeRef = useRef(mode);
    useEffect(function () {
        contextModeRef.current = mode;
    }, [mode]);
    var updateGeofenceData = function (action, geofence) {
        var newGeofences = [];
        var newMetaData = geofences.metaData;
        if (action === 'add') {
            newGeofences = __spreadArray([geofence], __read(geofences.data), false);
            newMetaData = __assign(__assign({}, geofences.metaData), { totalItems: geofences.metaData.totalItems + 1, totalPages: Math.ceil((geofences.metaData.totalItems + 1) /
                    geofences.metaData.itemsPerPage) });
        }
        else if (action === 'update') {
            var index = geofences.data.findIndex(function (item) { return item._id === geofence._id; });
            newGeofences = __spreadArray([], __read(geofences.data), false);
            newGeofences[index] = geofence;
        }
        else if (action === 'delete') {
            newGeofences = geofences.data.filter(function (item) { return item._id !== geofence._id; });
            newMetaData = __assign(__assign({}, geofences.metaData), { totalItems: geofences.metaData.totalItems - 1, totalPages: Math.ceil((geofences.metaData.totalItems - 1) /
                    geofences.metaData.itemsPerPage) });
        }
        setGeofences(function () {
            return {
                metaData: newMetaData,
                data: newGeofences,
            };
        });
    };
    return (React.createElement(GroupGeofencePageContext.Provider, { value: {
            selectedGeofence: selectedGeofence,
            setSelectedGeofence: setSelectedGeofence,
            postGeofenceModal: postGeofenceModal,
            setPostGeofenceModal: setPostGeofenceModal,
            geofences: geofences,
            setGeofences: setGeofences,
            updateGeofenceData: updateGeofenceData,
            mode: mode,
            setMode: setMode,
            geofenceAction: geofenceAction,
            setGeofenceAction: setGeofenceAction,
            setSearchGeofence: setSearchGeofence,
            searchGeofence: searchGeofence,
            contextModeRef: contextModeRef,
        } }, children));
};
export { GroupGeofencePageContextProvider, useGroupGeofencePageContext, GroupGeofencePageContext, };
